export default __webpack_public_path__ + "static/media/facebook.033c50dd.svg";